import KeyValue from "../structures/keyValePair"

class SchemaField {

    static DEF_DATA_CALC_TYPE = "defaultDataCalcType"
    static VISIBILITY = "visibility"
    static DEF_SCALE = "defaultScale"
    static DESCRIPTORS = "descriptors"
}

class SchemaNames {
    static IS = "Income Statement"
    static CF = "Cash Flow"
    static BS = "Balance Sheet"
    static KPIs = "KPIs"
    static SEG_BY_PROD = "Segments by Product"
    static SEG_BY_REG = "Segments by Region"
    static RECONCILIATIONS = "Reconciliations"
    static ALL_OPT = [SchemaNames.KPIs, SchemaNames.SEG_BY_PROD, SchemaNames.SEG_BY_REG, SchemaNames.RECONCILIATIONS].map(name => new KeyValue(name, name))
}

const RECONCILIATIONS_ALIASES = ['Reconciliation', 'Reconciliations'];

const NO_OP_CALC = "NO_OP" 

class DescriptorColors {
    static DEPRECATED_TO_REPLACED_COLOR_MAP = {
        '#8fceff': '#bee6b5',
        '#6fe36f': '#bee6b5',
        '#fafa4b': '#FFFFB8',
    };

    static ALL_AS_KV = [
        new KeyValue('inherit', "Default"),
        new KeyValue('#ebebeb', "Grey"),
        new KeyValue('#FFFFB8', "Yellow"),
        new KeyValue('#bee6b5', "Green"),
        new KeyValue('#D9EAF7', "Blue"),
        new KeyValue('#FCE4D6', "Peach"),
        new KeyValue('#E8E0F5', "Purple"),
    ]

}

class BranchTypes {
    static MAIN = "MAIN"
    static EDIT = "EDIT"
    static REVIEW = "REVIEW"
}

export { SchemaField, SchemaNames, DescriptorColors, NO_OP_CALC, BranchTypes,RECONCILIATIONS_ALIASES }